import { createSvgIcon } from "@mui/material";

/**
 * This is a copy of the path from MUI's CheckBoxOutlineBlank icon but with an added rect for a solid background.
 */
const CheckboxBlankSolidIcon = createSvgIcon(
  <>
    <path d="M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z" fill="currentColor" />
    <rect x="5" y="5" width="14" height="14" fill="white" />
  </>,
  "CheckboxBlankSolidIcon"
);

export default CheckboxBlankSolidIcon;
